import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout eyebrow="Legal · Privacy" title="Privacy Policy & GDPR Notice" effective="Effective Date: July 2026 · PerCen360.com – PerCen Technologies Ltd">
      <section>
        <h2 className="font-display text-xl mb-2">Introduction</h2>
        <p>PerCen Technologies Ltd (“we”, “us”) operates PerCen360.com. We are committed to protecting your privacy and complying with GDPR and Irish data protection law.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Data We Collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account details (name, email)</li>
          <li>Financial and receipt data you upload</li>
          <li>Grant and compliance information</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">How We Use Your Data</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Deliver the PerCen360 service (expense management, grant tracking, reporting)</li>
          <li>Generate VAT3, CRO, and investor reports</li>
          <li>Improve the platform (anonymised analytics only)</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Lawful Basis</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Contract (providing the service)</li>
          <li>Legal obligation (Revenue/CRO compliance)</li>
          <li>Legitimate interest (product improvement)</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Data Sharing</h2>
        <p>We do not sell data. Data is only shared with your explicit accountant or as legally required. Processing takes place on GDPR-compliant cloud infrastructure; our current data-residency region is confirmed with our hosting provider and available on request.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Security</h2>
        <p>Data is encrypted at rest and in transit. We use industry-standard security controls (access controls, MFA, and immutable audit logs). However, no system is 100% secure.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Your Rights</h2>
        <p>You have the right to access, correct, delete, restrict, or port your data. Contact <a className="text-[#FFB020] underline" href="mailto:gillian@percen360.com">gillian@percen360.com</a>.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Retention</h2>
        <p>We retain data for the duration of your account + 7 years for legal compliance.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">International Transfers</h2>
        <p>We aim to keep personal data within the EU. Where any transfer outside the EEA occurs, it is protected by appropriate safeguards (e.g. Standard Contractual Clauses). Contact us for our latest data-processing and residency statement.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Liability</h2>
        <p>We are not liable for any loss arising from your use of PerCen360. The platform is a support tool only – you remain responsible for your own compliance and financial decisions.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Contact</h2>
        <p>Data Controller: Gillian Berry, PerCen Technologies Ltd, <a className="text-[#FFB020] underline" href="mailto:gillian@percen360.com">gillian@percen360.com</a>.</p>
      </section>
    </LegalLayout>
  );
}
